// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageInternalError{margin-bottom:3rem}.PageInternalError__iconWrapper{align-items:center;border:1px solid #dee2e6;display:flex;font-size:12rem;height:100%;justify-content:center;line-height:1;margin:auto;padding:3rem;text-align:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
